module.exports = __webpack_public_path__ + "img/ios-star.4e4ace47.svg";